import React from 'react';
import { Modal } from 'react-bootstrap';
import './ActivateAccountModal.scss';

interface ActivateAccountModalProps {
  show: boolean;
  onHide: () => void;
  customerName?: string;
  onConfirm?: () => void;
}

const ActivateAccountModal: React.FC<ActivateAccountModalProps> = ({
  show,
  onHide,
  customerName = 'Customer',
  onConfirm,
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onHide();
  };

  const handleCancel = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="activate-account-modal"
    >
      <Modal.Body>
        <h2 className="modal-title">
          Are you sure you want to activate {customerName}'s account?
        </h2>

        <p className="modal-description">
          This will restore full access to the customer's account and they will be able to use all features.
        </p>

        <div className="modal-actions">
          <button className="btn btn-confirm" onClick={handleConfirm}>
            YES, ACTIVATE
          </button>
          <button className="btn btn-cancel" onClick={handleCancel}>
            CANCEL
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActivateAccountModal;
